import React from 'react';

import { localStorageVariables } from '@/types/localStorageVariables';
import localizationService, {
  useTranslation,
  translate,
  Trans,
  i18n
} from 'yardi-react-translation/translationService';

interface ApplicationLoadingScreenProps {
  message?: string;
}

export const ApplicationLoadingScreen: React.FC<ApplicationLoadingScreenProps> = ({
  message = 'Loading your application...'
}) => {
  const { t:translate } = useTranslation();
  const displayMessage = message || translate('Loading your application...');
  return (
    
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          {/* Spinning loader matching ApplicationCharges style */}
          <div className="relative">
            <div className="animate-spin rounded-full h-16 w-16 border-4 border-gray-200 border-t-primary mx-auto"></div>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-8 h-8 bg-primary rounded-full opacity-20 animate-pulse"></div>
            </div>
          </div>
          
          {/* Loading message */}
          <div className="mt-6 space-y-2">
            <p className="text-lg font-medium text-foreground">{translate(displayMessage)}</p>
            <p className="text-sm text-muted-foreground">
              {translate('Please wait while we process your request...')}
            </p>
          </div>
          
          {/* Progress dots animation */}
          <div className="flex justify-center mt-4 space-x-1">
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce"></div>
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
          </div>
        </div>
      </div>
    
  );
}; 